import React from 'react';
import { Provider } from 'react-redux';
import UserflowTheme from '@lt/components/themes/userflow';

import UIGlobalStyles from '@lt/components/styles/styles';
import ErrorBoundary from 'src/error/components/ErrorBoundary';
import { isSSR } from 'src/helpers/ssr';
import Layout from 'src/components/Layout';
import LazyExpensiveHotelsPopup from 'src/components/ExpensiveHotelsPopup';
import LazySeamlessTBankAuth from 'src/components/SeamlessTBankAuth';
import { setPageColors } from 'src/hooks/setPageColors';
import getStore from './store';

// Contants:
import { MODULE_NAME } from '../../constants';
import {
  LayoutMobile as HotelMobile,
  LayoutDesktop as HotelDesktop,
} from './containers/Layout';

// Components:

// Styles:
import './global/globalStyles.module.css';

interface IHotelApp {
  isMobile?: boolean;
  isWhitelabel?: boolean;
  wlPartnerSettings?: any;
}

const HotelApp = (props: IHotelApp) => {
  const { isMobile = false, isWhitelabel = false, wlPartnerSettings } = props;

  const store = getStore(props);
  console.log(store.getState());

  try {
    if (isWhitelabel && wlPartnerSettings)
      setPageColors({
        primary: wlPartnerSettings.primary,
        primaryColor: wlPartnerSettings.primaryColor,
        primaryHeader: wlPartnerSettings.primaryHeader,
        primaryHeaderColor: wlPartnerSettings.primaryHeaderColor,
        secondary: wlPartnerSettings.secondary,
        secondaryColor: wlPartnerSettings.secondaryColor,
        secondaryHeader: wlPartnerSettings.secondaryHeader,
        secondaryHeaderColor: wlPartnerSettings.secondaryHeaderColor,
      });
  } catch (e) {
    console.log(e);
  }

  return (
    <ErrorBoundary>
      <Provider store={store}>
        <UserflowTheme>
          <>
            <UIGlobalStyles />
            <Layout appName={MODULE_NAME.HOTEL}>
              {isMobile ? <HotelMobile /> : <HotelDesktop />}

              {!isSSR && !isWhitelabel ? <LazyExpensiveHotelsPopup /> : null}
            </Layout>

            <LazySeamlessTBankAuth />
          </>
        </UserflowTheme>
      </Provider>
    </ErrorBoundary>
  );
};

export default HotelApp;
